import React from 'react'
import Withdrawal from '@commons/withdraw'

const WithdrawalReleased = () => {
  return <Withdrawal status={'Approved'} />
}

export default WithdrawalReleased
